import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AiChatService, ChatCommand } from '../services/ai-chat.service';
import { SUGGESTIONS } from './sugesstions.comstant';

@Component({
  selector: 'ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss'],
  animations: [
    trigger('messageAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.5s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class AiChatComponent implements OnInit, OnDestroy, AfterViewInit {
  userInput = '';
  isFullScreen = false;
  chatCommand = ChatCommand;
  suggestions: string[];
  promtLoading = false;

  @ViewChild('chatWindow') chatWindow!: ElementRef;
  @ViewChild('inputField') inputField!: ElementRef;

  private originalWidth: string | undefined;
  private originalHeight: string | undefined;
  private originalPosition: { left?: string; top?: string } | undefined;

  private destroy$ = new Subject<void>();

  constructor(
    public aiChatService: AiChatService,
    public dialogRef: MatDialogRef<AiChatComponent>
  ) {}

    ngOnInit(): void {
      this.suggestions = SUGGESTIONS.General;
    this.aiChatService.chatHistory$
      .pipe(takeUntil(this.destroy$))
      .subscribe(history => {
        if (history.length === 0 && !this.aiChatService.hiFlag) {
          this.aiChatService.sendMessage('Hi! ');
        }
      });
  }

  ngAfterViewInit(): void {
    this.inputField.nativeElement.focus();
    this.aiChatService.chatHistory$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      setTimeout(() => this.scrollToBottom(), 0);
    });
  }

  async sendMessage(): Promise<void> {
    const trimmedMessage = this.userInput.trim();
    if (!trimmedMessage) return;

    this.userInput = '';
    setTimeout(() => this.scrollToBottom(), 0);

    try {
      await this.aiChatService.sendMessage(trimmedMessage);
    } catch (error) {
      console.error('Error receiving response:', error);
    } finally {
      setTimeout(() => this.scrollToBottom(), 0);
    }
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  chipSelected(value: string): void {
    switch(value){
      case ChatCommand.FindCustomers:
        this.suggestions = SUGGESTIONS.FindCustomersOfProducts
        break;
      case ChatCommand.AnalyzeTechStacks:
        this.suggestions = SUGGESTIONS.AnalyzeTechStacksForCompanies
        break;
      case ChatCommand.BenchmarkCompanies:
        this.suggestions = SUGGESTIONS.BenchmarkCompanies
        break;
      case ChatCommand.GeneralMode:
        this.suggestions = SUGGESTIONS.General;
        break;
      case ChatCommand.RecommendSoftware:
        this.suggestions = SUGGESTIONS.RecommendedSoftware;
        break;
      default:
      this.suggestions = SUGGESTIONS.General;
      break;
    }
    this.userInput = value;
    this.sendMessage();
    this.inputField.nativeElement.focus();
  }

  toggleExpand(): void {
    this.dialogRef.close();
  }

  private scrollToBottom(): void {
    if (this.chatWindow && this.chatWindow.nativeElement) {
      const element = this.chatWindow.nativeElement;
      const start = element.scrollTop;
      const end = element.scrollHeight - element.clientHeight;
      const duration = 50; // Длительность анимации в миллисекундах
      let startTime: number | null = null;

      const animateScroll = (currentTime: number) => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);

        // Ease-in-out функция
        const ease = progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;

        element.scrollTop = start + (end - start) * ease;

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    }
  }
  public clearChat(): void {
    this.aiChatService.clearChatHistory();
  }

  public closeChat(): void {
    this.clearChat();
    this.dialogRef.close();
  }

  public toggleSize(): void {
    if (this.isFullScreen) {
      this.restoreOriginalSize();
    } else {
      this.centerAndResize();
    }
    this.isFullScreen = !this.isFullScreen;
  }

  public async refreshPromts(): Promise<void> {
    this.promtLoading = true;
    const newSuggestion = await this.aiChatService.refreshPrompts() ?? SUGGESTIONS.General
    this.suggestions.length =0;
    this.suggestions.push(...newSuggestion);
    this.promtLoading = false;
  }

  private centerAndResize(): void {
    if (!this.originalWidth || !this.originalHeight) {
      this.originalWidth = this.dialogRef._containerInstance._config.width;
      this.originalHeight = this.dialogRef._containerInstance._config.height;
      this.originalPosition = this.dialogRef._containerInstance._config.position || {};
    }

    const width = Math.min(window.innerWidth * 0.9, 1200);
    const left = (window.innerWidth - width) / 2;

    this.dialogRef.updateSize(`${width}px`, `${this.originalHeight}px`);
    this.dialogRef.updatePosition({ left: `${left}px`, bottom: `0px` });
    this.dialogRef.removePanelClass('animate__slideInUp');
    this.dialogRef.addPanelClass(['animate__slideInRight', 'animate__zoomIn']);
  }

  private restoreOriginalSize(): void {
    if (this.originalWidth && this.originalHeight) {
      this.dialogRef.updateSize(this.originalWidth, this.originalHeight);
    }
    if (this.originalPosition) {
      this.dialogRef.updatePosition(this.originalPosition);
    }
    this.dialogRef.removePanelClass('animate__slideInRight');
    this.dialogRef.addPanelClass(['animate__slideInLeft', 'animate__zoomOut']);
  }




    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}